module.exports = __webpack_public_path__ + "img/about-us.10d54974.png";